<template>
  <el-dialog :title="title" :visible.sync="visible" width="500px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" :show-message="showMessage">
      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入序号" @focus="inputFocus"></el-input>
      </el-form-item>
      <el-form-item label="跳转链接地址" prop="url">
        <el-input v-model="form.url" placeholder="请输入跳转链接地址" @focus="inputFocus"></el-input>
      </el-form-item>
      <el-form-item label="轮播图" prop="pictureKey">
        <el-upload
          v-if="visible"
          ref="upload"
          v-loading="uploading"
          class="avatar-uploader"
          action=""
          :show-file-list="false"
          :auto-upload="false"
          :accept="acceptType.join(',')"
          :on-change="handleChange"
          @click="inputFocus"
        >
          <file-image v-if="form.pictureKey" :key="form.pictureKey" :preview="false" :src="form.pictureKey" fit="contain" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="轮播图详情" prop="detail">
        <el-input v-model="form.detail" type="textarea" :rows="5"></el-input>
      </el-form-item>
      <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
        <el-form-item v-show="!showMessage && errTips !== ''" class="err-tips">
          <span><i class="el-icon el-icon-remove"></i>{{errTips}}</span>
        </el-form-item>
      </transition>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="!canSubmit" type="primary" style="width: 120px;" @click="handleUpdate">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { PUT_IMAGE_UPLOAD, PUT_SLIDE_SHOWS, POST_SLIDE_SHOWS } from '@/utils/api'
import FileImage from '@/components/file-image'

export default {
  name: 'EditDialog',

  components: {
    'file-image': FileImage
  },

  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    },

    item: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },

  data () {
    // 检查排序
    this.checkSort = (rule, value, callback) => {
      let errTips = ''
      if (value === '') {
        errTips = '请输入排序'
      } else if (!this.$verification.isPositiveReg.test(value)) {
        errTips = '请输入正确的排序'
      }

      if (errTips) {
        !this.errTips && (this.errTips = errTips)
        callback(new Error(errTips))
      } else {
        callback()
      }
    }

    this.checkValue = (rule, value, callback, tips) => {
      let errTips = ''
      if (value === '') {
        errTips = tips
      }

      if (errTips) {
        !this.errTips && (this.errTips = errTips)
        callback(new Error(errTips))
      } else {
        callback()
      }
    }

    return {
      title: '',
      uploading: false,
      form: {
        pictureKey: '',
        sort: '1',
        url: '',
        detail: ''
      },
      acceptType: ['.jpeg', '.png', '.jpg', '.svg'],
      showMessage: true,
      rules: {
        sort: [
          {required: true, validator: this.checkSort, trigger: 'blur'}
        ],
        url: [
          {required: true, validator: (rule, value, callback) => this.checkValue(rule, value, callback, '请输入跳转链接地址'), trigger: 'blur'}
        ],
        detail: [
          {required: true, validator: (rule, value, callback) => this.checkValue(rule, value, callback, '请输入轮播图详情'), trigger: 'blur'}
        ],
        pictureKey: [
          {required: true, validator: (rule, value, callback) => this.checkValue(rule, value, callback, '请上传图片'), trigger: 'blur'}
        ]
      },
      errTips: ''
    }
  },

  computed: {
    canSubmit () {
      return this.form.sort !== '' && this.form.url !== '' && this.form.detail !== '' && this.form.pictureKey !== ''
    }
  },

  watch: {
    visible (val) {
      if (this.item.hasOwnProperty('id')) {
        this.title = '编辑轮播图'
        this.form = Object.assign({
        }, this.item)
      } else {
        this.title= '新增轮播图'
        this.form = {
          pictureKey: '',
          sort: '1',
          url: '',
          detail: ''
        }
      }
      setTimeout(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      }, val ? 0 : 300)
    },

    showMessage (val) {
      !val && (this.errTips = '')
    }
  },

  methods: {
    // 关闭前
    handleClose () {
      this.$emit('close')
    },

    // 数据更新前
    handleUpdate () {
      this.showMessage = false
      setTimeout(() => {
        this.submit()
      }, 10)
    },

    // 提交数据
    submit () {
      this.$refs.form &&
      this.$refs.form.validate(async validateResult => {
        if (validateResult) {
          try {
            const isEdit = this.item.hasOwnProperty('id')
            const data = Object.assign({}, this.form)
            isEdit ? await POST_SLIDE_SHOWS(this.item.id, data) : await PUT_SLIDE_SHOWS(data)
            this.$message.success(isEdit ? '编辑成功' : '新增成功')
            this.$emit('update')
          } catch (e) {
            console.log(e)
            this.$message.error('操作失败')
          }
        }
      })
    },

    // 输入框聚焦
    inputFocus () {
      !this.showMessage && this.$refs.form && this.$refs.form.clearValidate()
      this.showMessage = true
    },

    async handleChange (file, fileList) {
      // 新增或替换
      // 类型校验失败
      if (!this.beforeUpload(file, fileList)) {
        return this.$refs.upload.clearFiles()
      }
      try {
        this.uploading = true
        const { key } = await PUT_IMAGE_UPLOAD(file)
        this.form.pictureKey = key
        this.$refs.upload.clearFiles()
      } finally {
        this.uploading = false
      }
    },

    beforeUpload (file, fileList) {
      const type = file.name.split('.')
      if (type.length === 1 && !this.acceptType.includes(type[type.length - 1])) {
        this.$message.error('文件类型错误')
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.err-tips {
  color: #F26552;

  /deep/ .el-form-item__content {
    text-align: center;
    font-size: 16px;
    background: rgba(255,242,244,1);
    border: 1px solid rgba(242,161,150,1);
  }

  .el-icon {
    margin-right: .8rem;
  }
}

.el-dialog__wrapper {
  /deep/ .el-dialog__footer {
    text-align: center;
  }
}
</style>
